/*
 * Écran de transition après le bilan : invite à vérifier si CYCLIQ
 * EXCELLENCE correspond, sans jamais employer de vocabulaire d'achat.
 * La qualification (CYCLIQ FIT) est un questionnaire séparé : le bilan
 * personnel reste identique quelle que soit la suite choisie.
 */

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export const TransitionSection = ({ onStart }) => (
  <section
    className="mt-10 rounded-2xl bg-[#E2F6FF] border border-[rgba(35,82,119,0.16)] p-6 sm:p-8 text-center"
    data-testid="bilan-transition-section"
  >
    <h2 className="font-heading text-xl sm:text-2xl font-semibold tracking-tight text-[#060606]">
      Ton bilan te parle ?
    </h2>
    <p className="mt-3 text-sm leading-relaxed text-[#333333] max-w-[520px] mx-auto" data-testid="bilan-transition-message">
      Tu viens d'identifier certaines tendances importantes dans ton fonctionnement. La
      prochaine étape consiste maintenant à déterminer si CYCLIQ EXCELLENCE peut réellement
      correspondre à ta situation, à tes objectifs et au niveau d'accompagnement que tu
      recherches.
    </p>
    <div className="mt-6 flex justify-center">
      <Button
        data-testid="bilan-start-fit-button"
        onClick={onStart}
        className="min-h-[52px] px-7 rounded-xl bg-[#235277] hover:bg-[#1E4767] text-white font-heading font-semibold text-base active:scale-[0.98] shadow-[var(--shadow-cta)] transition-colors duration-200"
      >
        Vérifier si CYCLIQ EXCELLENCE me correspond
        <ArrowRight className="ml-2 w-4 h-4" aria-hidden="true" />
      </Button>
    </div>
    <p className="mt-4 text-xs leading-relaxed text-[#9E9E9E] max-w-[520px] mx-auto">
      Quelques questions rapides, sans engagement. Ton bilan reste identique quelle que soit ta réponse.
    </p>
  </section>
);
